import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Building2, X, RefreshCw } from 'lucide-react';
import BotonAcceso from "../elementos/BotonAcceso";
import { useTheme } from "../guardarToken/themeContext";
import { CircularProgress } from "@mui/material";

const apiUrlSedes = process.env.REACT_APP_API_SEDES;

const EditSede = () => {
    const [nombre, setNombre] = useState('');
    const [codigo, setCodigo] = useState('');
    const [activo, setActivo] = useState(true);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const navigate = useNavigate();
    const { isDarkMode } = useTheme();

    useEffect(() => {
        getSedeById();
    }, []);

    const getSedeById = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${apiUrlSedes}`);
            // Buscamos en la lista ya que no hay endpoint individual por defecto en el back que vi, 
            // pero mejor crearé uno o buscaré el id en el array devuelto si es lo que hay.
            // En mi controlador getAllSedes devuelve todos.
            const sede = res.data.find(s => s.id === parseInt(id));
            if (sede) {
                setNombre(sede.nombre);
                setCodigo(sede.codigo);
                setActivo(sede.activo);
            }
        } catch (error) {
            console.error('Error al obtener la sede:', error);
        } finally {
            setLoading(false);
        }
    };

    const update = async (e) => {
        e.preventDefault();
        try {
            await axios.put(`${apiUrlSedes}${id}`, { nombre, codigo, activo });
            navigate('/admin/AbmSedes');
        } catch (error) {
            console.error('Error al actualizar la sede:', error);
            alert(error.response?.data?.message || 'Error al actualizar la sede');
        }
    };

    if (loading) {
        return (
            <div className={`min-h-screen flex items-center justify-center ${isDarkMode ? "bg-slate-950" : "bg-slate-50"}`}>
                <CircularProgress color="primary" />
            </div>
        );
    }

    return (
        <div className={`min-h-screen flex items-center justify-center p-4 ${isDarkMode ? "bg-slate-950" : "bg-slate-50"}`}>
            <div className={`w-full max-w-md ${isDarkMode ? "bg-slate-900 border-slate-800" : "bg-white border-slate-200"} rounded-3xl shadow-2xl border p-8 animate-in zoom-in duration-300`}>
                <div className="flex flex-col items-center mb-8">
                    <div className="bg-gradient-to-br from-blue-500 to-blue-700 p-4 rounded-2xl shadow-lg shadow-blue-900/30 mb-4">
                        <Building2 className="text-white w-8 h-8" />
                    </div>
                    <h2 className="text-2xl font-black tracking-tight mb-1">Editar Sede</h2>
                    <p className={`text-xs font-bold uppercase tracking-widest ${isDarkMode ? "text-slate-500" : "text-slate-400"}`}>Modificar unidad operativa</p>
                </div>

                <form onSubmit={update} className="space-y-5">
                    <div>
                        <label className={`block text-[10px] font-black uppercase tracking-widest mb-2 px-1 ${isDarkMode ? "text-slate-500" : "text-slate-400"}`}>Nombre de la Sede</label>
                        <input
                            type="text"
                            placeholder="Ej: Barracas"
                            className={`w-full px-5 py-3.5 rounded-2xl text-sm font-bold transition-all focus:outline-none focus:ring-2 focus:ring-blue-500/20 ${isDarkMode ? "bg-slate-950 border-slate-800 text-white" : "bg-slate-50 border-slate-100 text-slate-800"
                                } border`}
                            value={nombre}
                            onChange={(e) => setNombre(e.target.value)}
                            required
                        />
                    </div>

                    <div>
                        <label className={`block text-[10px] font-black uppercase tracking-widest mb-2 px-1 ${isDarkMode ? "text-slate-500" : "text-slate-400"}`}>Código Corto</label>
                        <input
                            type="text"
                            placeholder="Ej: BR"
                            className={`w-full px-5 py-3.5 rounded-2xl text-sm font-bold transition-all focus:outline-none focus:ring-2 focus:ring-blue-500/20 ${isDarkMode ? "bg-slate-950 border-slate-800 text-white" : "bg-slate-50 border-slate-100 text-slate-800"
                                } border`}
                            value={codigo}
                            onChange={(e) => setCodigo(e.target.value)}
                            required
                        />
                    </div>

                    <div className="flex items-center gap-2 px-1">
                        <input
                            type="checkbox"
                            id="activo"
                            checked={activo}
                            onChange={(e) => setActivo(e.target.checked)}
                            className="w-4 h-4 accent-blue-500"
                        />
                        <label htmlFor="activo" className={`text-[10px] font-black uppercase tracking-widest ${isDarkMode ? "text-slate-400" : "text-slate-500"}`}>Sede Activa</label>
                    </div>

                    <div className="flex gap-3 pt-4">
                        <BotonAcceso
                            variant="accent"
                            type='submit'
                            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-black text-xs uppercase tracking-widest h-14 rounded-2xl shadow-xl shadow-blue-900/20 flex items-center justify-center gap-2 transform active:scale-95 transition-all"
                        >
                            <RefreshCw className="w-4 h-4" /> Actualizar
                        </BotonAcceso>
                        <BotonAcceso
                            variant="dark"
                            type='button'
                            onClick={() => navigate('/admin/AbmSedes')}
                            className={`flex-1 ${isDarkMode ? "bg-slate-800 hover:bg-slate-700" : "bg-slate-100 hover:bg-slate-200 text-slate-600"} font-black text-xs uppercase tracking-widest h-14 rounded-2xl flex items-center justify-center gap-2 transition-all`}
                        >
                            <X className="w-4 h-4" /> Cancelar
                        </BotonAcceso>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditSede;
